// Geometry helpers of the guide video. Every scene is drawn on a fixed
// 1280×720 stage that is scaled to the player, so the cursor and the
// spotlight aim at exact rectangles in any language and at any size.

export const STAGE_W = 1280;
export const STAGE_H = 720;

export const clamp01 = (value) => Math.min(1, Math.max(0, value));
export const easeInOut = (t) => (t < 0.5 ? 2 * t * t : 1 - ((-2 * t + 2) ** 2) / 2);
/** 0 → 1 while `p` goes from `from` to `to`. */
export const span = (p, from, to) => clamp01((p - from) / (to - from));
/** The first part of `text`, as if typed between `from` and `to`. */
export const typed = (text, p, from, to) => text.slice(0, Math.round(text.length * span(p, from, to)));
export const between = (p, from, to) => p >= from && p < to;
/** The value of the first [until, value] step that `p` has not passed. */
export const pick = (p, steps) => steps.find(([until]) => p < until)?.[1] ?? steps[steps.length - 1][1];

export const center = (rect) => ({ x: rect.x + rect.w / 2, y: rect.y + rect.h / 2 });
export const grow = (rect, by = 6) => ({ x: rect.x - by, y: rect.y - by, w: rect.w + by * 2, h: rect.h + by * 2 });
/** Absolute CSS position of a stage rectangle. */
export const abs = (rect) => ({ left: rect.x, top: rect.y, width: rect.w, height: rect.h });

/** A cursor keyframe on the centre of `rect` (optionally offset, optionally a click). */
export const key = (p, rect, extra = {}) => {
  const point = center(rect);
  return { p, x: point.x + (extra.dx || 0), y: point.y + (extra.dy || 0), click: Boolean(extra.click) };
};
/** A cursor keyframe at a point. */
export const point = (p, x, y, click = false) => ({ p, x, y, click });
